import { render, staticRenderFns } from "./festivalUse.vue?vue&type=template&id=2837b0a7&scoped=true&"
import script from "./festivalUse.vue?vue&type=script&lang=js&"
export * from "./festivalUse.vue?vue&type=script&lang=js&"
import style0 from "./festivalUse.vue?vue&type=style&index=0&id=2837b0a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837b0a7",
  null
  
)

export default component.exports